import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';

export interface NavbarProfileItem {
	label: string;
	action: () => void;
	image?: string;
	isSeparator?: boolean;
	isActive?: boolean;
}

@Component({
	selector: 'peps-navbar-profile-button',
	imports: [NgClass],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './navbar-profile-button.component.html',
})
export class NavbarProfileButtonComponent implements OnInit, OnDestroy {

	@Input() text: string = '';
	@Input() picture: string = '';
	@Input() items: NavbarProfileItem[] = [];

	isOpen = false;
	isMobile = false;

	select(action: () => void) {
		action();
		if (this.isMobile) this.isOpen = false;
	}

	ngOnInit() {
		this.isMobile = window.innerWidth < 1024;
		window.addEventListener('resize', this.updateDeviceMode.bind(this));
	}

	ngOnDestroy() {
		window.removeEventListener('resize', this.updateDeviceMode.bind(this));
	}

	updateDeviceMode() {
		this.isMobile = window.innerWidth < 1024;
		if (!this.isMobile) this.isOpen = false;
	}

	handleClick() {
		if (this.isMobile) this.isOpen = !this.isOpen;
	}
}
